module.exports = __webpack_public_path__ + "static/media/ehealth_pro_acc_p4_1.42047ed6.png";